import { AMENITY_TYPE_PRIORITY } from "constants/index";
import sortedTagsList from "./constants";

export const getTags = (data: any) => {
  const tags: any = [];
  data?.forEach((d: any) => {
    if (d?.display_name) {
      tags.push(d.display_name);
    }
  });
  return tags;
};

export const getFeatures = (data: any) => {
  const tags: any = [];
  data?.forEach((d: any) => {
    if (d?.name) {
      tags.push(d.name);
    }
  });
  return tags;
};

// export const getTopAmenitySection = (data: any, forEn = false) => {
//   for (const type of AMENITY_TYPE_PRIORITY) {
//     const found = data?.find((d: any) => (forEn ? d?.type_en : d?.type) === type);
//     if (found) return found;
//   }
//   return null;
// };

export const getTopAmenitySections = (data: any, count = 2, forEn = false) => {
  const results: any[] = [];
  for (const type of AMENITY_TYPE_PRIORITY) {
    if (results.length >= count) break;
    const found = data?.find((d: any) => (forEn ? d?.type_en ?? d?.type : d?.type) === type);
    if (found && !results.includes(found)) results.push(found);
  }
  return results;
};

export const sortAmenitySections = (data: any, forEn = false) =>
  [...(data || [])].sort((a: any, b: any) => {
    const typeA = forEn ? a?.type_en ?? a?.type : a?.type;
    const typeB = forEn ? b?.type_en ?? b?.type : b?.type;
    const indexA = AMENITY_TYPE_PRIORITY.indexOf(typeA);
    const indexB = AMENITY_TYPE_PRIORITY.indexOf(typeB);
    // Items not in priority list go to end
    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });

export const getAmenities = (tags: any = [], data: any, forEn = false) => {
  const tagsLower = tags.map((t: string) => t?.toLowerCase());
  // Group amenities by type
  const amenitiesByType: Record<string, any[]> = {};
  data?.forEach((d: any) => {
    const type = d?.type_en ?? d?.type;
    if (AMENITY_TYPE_PRIORITY.includes(type)) {
      d?.values?.forEach((tag: any) => {
        const tagName = forEn ? tag?.name_en : tag?.name;
        if (!tagsLower.includes(tagName?.toLowerCase())) {
          if (!amenitiesByType[type]) amenitiesByType[type] = [];
          amenitiesByType[type].push(tagName);
        }
      });
    }
  });
  // Flatten in priority order
  let newTags: any[] = [];
  AMENITY_TYPE_PRIORITY.forEach((type: any) => {
    if (amenitiesByType[type]) {
      newTags = newTags.concat(amenitiesByType[type]);
    }
  });
  return tags ? [...tags, ...newTags] : newTags;
};

export const getCommonAmenities = getAmenities;

export const executeScrollToPosition = ({ node, offset, scrollingElement = window }: any) => {
  if (!node) return;
  const elementPosition = node.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - offset;
  scrollingElement.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });
};

export const getShowPropertyInfoTags = (propertyInfoTags: any) => {
  let value = false;
  if (propertyInfoTags) {
    propertyInfoTags.forEach((tag: any) => {
      if (tag?.value > 0) value = true;
    });
  }
  return value;
};

export const getSortedTags = (tagList: any) =>
  tagList
    ?.filter((tag: string) => tag !== "not_available") // Remove not available tag used by CRM
    ?.map((tag: string) => tag?.replace(/_/g, " ")) // Remove underscores
    ?.slice() // To prevent mutation
    // Sort according to provided sorted list array
    ?.sort((a: any, b: any) => {
      // Move items not present to end
      if (sortedTagsList.indexOf(b?.toLowerCase()) === -1) {
        return -1;
      }
      if (sortedTagsList.indexOf(a?.toLowerCase()) === -1) {
        return 1;
      }
      // Sort according to list provided
      return sortedTagsList?.indexOf(a?.toLowerCase()) - sortedTagsList?.indexOf(b?.toLowerCase());
    }) || [];

export const milesToKilometersConverter = (distance: any) => {
  const distanceStr = distance?.toString()?.toLowerCase();
  const isMiles = distanceStr?.includes("mi");
  const isFeet = distanceStr?.includes("ft") || distanceStr?.includes("feet");
  const numericValue = parseFloat(distanceStr?.replace(/[^\d.]/g, ""));

  let kilometers = 0;

  if (isMiles) {
    kilometers = numericValue * 1.60934;
  } else if (isFeet) {
    kilometers = numericValue * 0.0003048;
  } else {
    kilometers = numericValue;
  }
  if (kilometers < 0.1) {
    kilometers = 0.1;
  }
  return `${kilometers.toFixed(1)} km`;
};
